import { defineComponent } from 'vue';
import UploadFileCode from '@/presentation/components/import-file/upload-file/upload-file.code';

export default defineComponent({
	setup: () => {
		const code = new UploadFileCode();

		return {
			uploadButton: code.uploadButton,
			processUpload: code.processUpload.bind(code)
		};
	}
});
